import _ from 'lodash';
import api from 'lib/api';
import notifications from 'lib/notifications';
import utils, { getDecryptedUrl } from 'lib/utils';
import { actions as userActions } from 'redux/user';
import { actions as miscActions } from 'redux/misc';

import { userService, authService } from 'services';

import config from 'config';
import { toast } from 'react-toastify';
import inMemoryJWT from 'services/auth/inMemoryJWT';
import storage from 'lib/storage';
import Cookies from 'js-cookie';
// import { showLoginBlockedModalFn } from 'components/CookieConsent';
import posthog from 'posthog-js';
import { clearPersistedCircleFilter } from 'lib/circleFilterStorage';

declare const gtag: any;

export async function handleRequestOTP(values, formikBag) {
  try {
    // Check if cookie consent is given
    const cookieConsent = Cookies.get('cookieConsent');
    if (cookieConsent !== 'accepted') {
      // Show modal explaining why login is blocked
      // showLoginBlockedModalFn();
      // Stop form submission
      formikBag.setSubmitting(false);
      return;
    }

    const res = await authService.sendLoginOTP({
      ...values,
    });
    // console.log('handleRequestOTP---->', res);

    globalThis.store.dispatch(
      miscActions.update({
        ...res,
        authStep: 'otp',
      }),
    );
  } catch (err) {
    utils.displayErrors(err as any, formikBag);
    console.log('handleRequestOTP->error--->>>', err);
  }
}

export async function handleRequestOTPforQuote(values, formikBag) {
  try {
    const res = await authService.sendLoginOTP({
      ...values,
    });
    // console.log('handleRequestOTP---->', res);

    // globalThis.store.dispatch(
    //   miscActions.update({
    //     ...res,
    //     authStep: 'otp',
    //   }),
    //   );
    // console.log('res==', res);
    localStorage.setItem('quoteVerification', JSON.stringify(res));
    return res;
  } catch (err) {
    utils.displayErrors(err as any, formikBag);
    console.log('handleRequestOTP->error--->>>', err);
  }
}

export async function handleOTPSubmit(values, formikBag, isMobile, isIPad) {
  const { indentDealsUrl } = config;
  const loc = getDecryptedUrl(window.location.href);

  try {
    // Check if cookie consent is given
    const cookieConsent = Cookies.get('cookieConsent');
    if (cookieConsent !== 'accepted') {
      // Show modal explaining why login is blocked
      // showLoginBlockedModalFn();
      // Stop form submission
      formikBag.setSubmitting(false);
      return;
    }

    const params = {
      ...values,
      isMobile,
      isIPad,
    };

    let res = {};
    res = await authService.login(params);
    // BFC-9035: fresh login starts with "All Circles" in the Global Circle Filter
    clearPersistedCircleFilter();

    // Identify user in PostHog with uuid (email or mobile entered by user) after successful login
    try {
      if (typeof window !== 'undefined' && posthog && typeof posthog.identify === 'function') {
        const uuid = values.user_name || values.mobile_number;
        if (uuid) {
          // Store uuid in localStorage for use in social feed
          await storage.setItem('posthog_uuid', uuid);
          posthog.identify(uuid, { uuid });
        }
      }
    } catch (e) {
      // best-effort; ignore errors
    }

    gtag('event', 'User_Login_Details', values);
    gtag('event', 'User_Login_Response', res);
    gtag('event', 'login', { ...res, ...values });
    if (window) {
      window.location.href = '/';
      if (loc.includes(`${indentDealsUrl}`)) {
        window.location.href = indentDealsUrl + '/dashboard';
      }
      return;
    }

    globalThis.store.dispatch(
      userActions.updateUser({
        ...res,
        isAuthenticated: false,
      }),
    );
    let userProfile = {};
    userProfile = await userService.fetchPersonalDetails({});

    globalThis.store.dispatch(
      miscActions.update({
        flush: true,
      }),
    );

    globalThis.store.dispatch(
      userActions.updateUser({
        ...res,
        ...userProfile,
        isAuthenticated: true,
      }),
    );
  } catch (err) {
    utils.displayErrors(err as any, formikBag);
  }
}

export async function handleOTPSubmitQuote(values, formikBag, isMobile, isIPad, setShowAccept) {
  const { indentDealsUrl } = config;
  const loc = getDecryptedUrl(window.location.href);
  // console.log('inside handleOTPSubmitQuote handler');
  try {
    const params = {
      ...values,
      isMobile,
      isIPad,
    };

    let res = {};
    res = await authService.loginQuote(params);
    // console.log('verify res', res);
    !_.isEmpty(res) ? setShowAccept(true) : setShowAccept(false);
    // window.location.href=`/printable-quote/${id}`
    // return res;

    // gtag('event', 'User_Login_Details', values);
    // gtag('event', 'User_Login_Response', res);
    // gtag('event', 'login', { ...res, ...values });
    // if (window) {
    //   window.location.href = '/';
    //   if (loc.includes(`${indentDealsUrl}`)) {
    //     window.location.href = indentDealsUrl + '/dashboard';
    //   }
    //   return;
    // }

    globalThis.store.dispatch(
      userActions.updateUser({
        ...res,
        isAuthenticated: false,
      }),
    );
    let userProfile = {};
    userProfile = await userService.fetchPersonalDetails({});

    globalThis.store.dispatch(
      miscActions.update({
        flush: true,
      }),
    );

    globalThis.store.dispatch(
      userActions.updateUser({
        ...res,
        ...userProfile,
        isAuthenticated: true,
      }),
    );
  } catch (err) {
    setShowAccept(false);
    utils.displayErrors(err as any, formikBag);
  }
}

export async function handleResendOTP(params) {
  try {
    let res = await authService.sendLoginOTP(params);
    globalThis.store.dispatch(
      miscActions.update({
        ...res,
        authStep: 'otp',
      }),
    );
    // console.log('onResendOTP->res', res);
  } catch (err) {
    utils.displayErrors(err as any);
  }
}

export async function createWhatsAppLoginToken() {
  try {
    const { baseUrl, whatsappPatToken } = config;
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/LoginviaWhatsApp/SaveandUpdateWhatsAppLoginToken`;
    const headers = {
      AccessToken: 'd9ef74d5fda3a174f3a6344e13360659e5301ff0aa789024e392ac5dc1075caf',
    };
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify({ create_Token: true }),
      headers,
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    const errors: any = await utils.processApiErrors(err);
    utils.displayErrors(errors);
    throw errors;
  }
}

export async function checkWhatsAppLoginToken(mobileNumber: string) {
  try {
    const { baseUrl, whatsappPatToken } = config;
    const token = localStorage.getItem('whatsapp_login_token') || '';
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/LoginviaWhatsApp/CheckLoginTokenviaMobileNumber`;
    const body = { mobile_Number: mobileNumber, token };
    const headers = {
      AccessToken: 'd9ef74d5fda3a174f3a6344e13360659e5301ff0aa789024e392ac5dc1075caf',
    };
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers,
    }).ready;
    const resData = await utils.processApiRes(res);
    const loginRes = _.get(resData, 'login_response', resData) as any;
    const jwt = _.get(loginRes, 'jwt_token') || _.get(loginRes, 'jwtToken') || _.get(loginRes, 'jwt');
    const jwtExpiry = _.get(loginRes, 'jwt_token_expire_datetime') || _.get(loginRes, 'jwtExpiry');
    const refreshToken = _.get(loginRes, 'refresh_token') || _.get(loginRes, 'refreshToken');

    if (jwt) {
      await inMemoryJWT.setToken(jwt, jwtExpiry);
    }
    if (refreshToken) {
      await inMemoryJWT.setRefreshToken(refreshToken);
    }

    const pid = _.get(loginRes, 'person_id') || _.get(resData, 'person_id');
    const sid = _.get(loginRes, 'social_profile_id') || _.get(resData, 'social_profile_id');
    if (pid) {
      await storage.setItem('pid', `${pid}`);
    }
    if (sid) {
      await storage.setItem('sid', `${sid}`);
    }

    // Identify user in PostHog with uuid (mobile number entered by user) after successful WhatsApp login
    try {
      if (typeof window !== 'undefined' && posthog && typeof posthog.identify === 'function') {
        if (mobileNumber) {
          // Store uuid in localStorage for use in social feed
          await storage.setItem('posthog_uuid', mobileNumber);
          posthog.identify(mobileNumber, { uuid: mobileNumber });
        }
      }
    } catch (e) {
      // best-effort; ignore errors
    }

    return resData;
  } catch (err) {
    const errors: any = await utils.processApiErrors(err);
    utils.displayErrors(errors);
    throw errors;
  }
}
